import Store from '../../src/redux';
import { sendRequestTardeManger } from './baseRequest';

const getHeaders = () => {
	const user = Store?.getState()?.user;
	return {
		'X-FNOTRADER-SECRET': user?.loginSecret,
		'X-FNOTRADER-USERID': user?.userID,
	};
};

export const createSignal = (payload) => {
	return sendRequestTardeManger('post', 'signals', payload, getHeaders());
};

export const updateSignal = (signalId, payload) => {
	return sendRequestTardeManger('post', `signal/${signalId}`, payload, getHeaders());
};

export const listSignals = () => {
	return sendRequestTardeManger('get', 'signals', null, getHeaders());
};

export const activateSignal = (signalId) => {
	return sendRequestTardeManger('post', `signal/${signalId}/activate`, {}, getHeaders());
};

export const deactivateSignal = (signalId) => {
	return sendRequestTardeManger('post', `signal/${signalId}/deactivate`, {}, getHeaders());
};

export const deleteSignal = (signalId) => {
	return sendRequestTardeManger('delete', `signal/${signalId}`, null, getHeaders());
};

export const getSignalWebhookUrl = (signalId) => {
	return sendRequestTardeManger('get', `signal/${signalId}/webhook`, null, getHeaders());
};

export const createSignalWebhook = (signalId) => {
	return sendRequestTardeManger('post', `signal/${signalId}/webhook`, {}, getHeaders());
};

export const listStrategies = (brokerId) => {
	const path = brokerId ? `strategies?broker_id=${brokerId}` : 'strategies';
	return sendRequestTardeManger('get', path, null, getHeaders());
};

export const updateStrategyBrokers = (strategyId, payload) => {
	return sendRequestTardeManger('post', `strategy/${strategyId}/brokers`, payload, getHeaders());
};

export const triggerSignal = (signalId) => {
	return sendRequestTardeManger('post', `signal/${signalId}/trigger`, {}, getHeaders());
};

export const getSignalLogs = (signalId) => {
	return sendRequestTardeManger('get', `signal/${signalId}/logs`, null, getHeaders());
};

export const getAllSignalLogs = () => {
	return sendRequestTardeManger('get', 'signals/logs', null, getHeaders());
};


